<celum-icon
  class="collapse-button_toggle"
  [attr.data-test-collapse-button-open]="!collapsed"
  [class.collapse-button_toggle--collapsed]="collapsed"
  [class.collapse-button_toggle-vertical]="verticalOrientation"
  [configuration]="icons.arrow"
  (click)="changed.emit()"></celum-icon>
